import { OfferType } from '@smg-real-estate/hg-rets-schema';
import {
  AgencyBasePackage,
  HgSupportedLanguage,
  TargetPlatform,
} from '@smg-real-estate/hg-search-libs';

export enum PriceDropAlertStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum PriceDropAlertSubscriptionType {
  EXPERT = 'Expert',
  PROFESSIONAL = 'Professional',
}

export enum PriceDropAlertSupportedChannel {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  EMAIL = 'EMAIL',
  UNKNOWN = 'UNKNOWN',
}

export enum PriceDropAlertAction {
  ACTIVATE_PRICE_DROP_ALERT = 'activatePriceDropAlert',
  DELETE_PRICE_DROP_ALERT = 'deletePriceDropAlert',
}

export interface PriceDropAlert {
  recipient: string;
  listingId: string;
  platform: TargetPlatform.HOMEGATE | TargetPlatform.IMMOSCOUT24;
  language: HgSupportedLanguage;
  status: PriceDropAlertStatus;
  price: number;
  name: string;
}

export interface CreatePriceDropAlertEmitPayload {
  name: string;
  recipient: string;
  listingId: string;
}

export interface CreatePriceDropAlertPayload {
  recipient: string;
  listingId: string;
  name: string;
  basePackage?: AgencyBasePackage;
  offerType: Lowercase<OfferType>;
  subscriptionType?: string;
  language: HgSupportedLanguage;
  price: number;
  channel: PriceDropAlertSupportedChannel;
}

export enum PriceDropAlertRequestStatus {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  PENDING = 'PENDING',
  FETCHED = 'FETCHED',
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  NO_TOKEN_ERROR = 'NO_TOKEN_ERROR',
  NOT_FOUND_ERROR = 'NOT_FOUND_ERROR',
  ALREADY_EXISTS_ERROR = 'ALREADY_EXISTS_ERROR',
}
